import { render } from "./ASFilozofiaNoastra.vue?vue&type=template&id=1a8ca7de"
import script from "./ASFilozofiaNoastra.vue?vue&type=script&lang=js"
export * from "./ASFilozofiaNoastra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__